import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";

import Dashboard from "./component/Dashboard/Dashboard";

// Pages
import CreateBlog from "./pages/CreateBlog";
import CreateCampaign from "./pages/CreateCampaign";
import TotalDonationPage from "./pages/TotalDonationPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import OverviewPage from "./pages/OverviewPage";
import OrdersPage from "./pages/OrdersPage";
import RidersPage from "./pages/RidersPage";
import VendorsPage from "./pages/VendorsPage";
import LocationPage from "./pages/LocationsPage";
import CategoriesPage from "./pages/CategoriesPage";
import ProductsPage from "./pages/ProductsPage";
import ProtectedRoute from "./context/ProtectedRoute";
import Login from "./component/Auth/Login";
import SystemSettingsPage from "./pages/SystemSettingsPage";
import NotificationsPage from "./pages/NotificationsPage";
import UsersPage from "./pages/UsersPage";

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* ✅ Root → Dashboard */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />

        {/* Public Route */}
        <Route path="/login" element={<Login />} />

        {/* Dashboard Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        >
          <Route index element={<OverviewPage />} />
          <Route path="orders" element={<OrdersPage />} />
          <Route path="riders" element={<RidersPage />} />
          <Route path="vendors" element={<VendorsPage />} />
          <Route path="locations" element={<LocationPage />} />
          <Route path="settings" element={<SystemSettingsPage />} />
          <Route path="notification" element={<NotificationsPage />} />
          <Route path="categories" element={<CategoriesPage />} />
          <Route path="products" element={<ProductsPage />} />
          <Route path="create-blog" element={<CreateBlog />} />
          <Route path="create-campaign" element={<CreateCampaign />} />
          <Route path="donations" element={<TotalDonationPage />} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route path="users" element={<UsersPage />} />
        </Route>

        {/* Catch all */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </AuthProvider>
  );
}
